import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import { Fragment, FunctionComponent, PropsWithChildren } from 'react';
import { useMainAppLayout } from '../../providers/MainAppLayoutProvider';

export const Sidebar: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { sidebarOpen, setSidebarOpen, isDesktop, mediaQueryLoading } =
    useMainAppLayout();

  const showMobileSidebar = !isDesktop && !mediaQueryLoading;
  const showDesktopSidebar = (isDesktop || mediaQueryLoading) && sidebarOpen;

  return (
    <>
      {showMobileSidebar && (
        <Transition show={Boolean(sidebarOpen)} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 mt-16 overflow-hidden"
            onClose={setSidebarOpen}
          >
            <div className="absolute inset-0 overflow-hidden">
              {/* darkened overlay */}
              <TransitionChild
                as={Fragment}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute inset-0 bg-overlay/80 transition-opacity" />
              </TransitionChild>
              {/* sidebar itself */}
              <div className="fixed inset-y-0 left-0 flex max-w-full">
                <TransitionChild
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700 motion-reduce:transition-none"
                  enterFrom="-translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700 motion-reduce:transition-none"
                  leaveFrom="translate-x-0"
                  leaveTo="-translate-x-full"
                >
                  <div className="relative w-screen max-w-xs">
                    {/* menu items */}
                    <DialogPanel className="bg-menu-background mt-16 flex h-full flex-col overflow-y-auto shadow-xl">
                      <div className="relative flex-1">
                        <nav>
                          <div className="grid grid-cols-1 divide-y">
                            {children}
                          </div>
                        </nav>
                      </div>
                    </DialogPanel>
                  </div>
                </TransitionChild>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}

      <Transition
        show={Boolean(showDesktopSidebar)}
        appear
        enter="ease-out duration-500 motion-reduce:transition-none"
        leave="ease-in duration-500 motion-reduce:transition-none"
        enterFrom="w-0"
        enterTo="w-64"
        leaveFrom="w-64"
        leaveTo="w-0"
      >
        <div className="hidden h-full overflow-x-hidden md:flex md:flex-col">
          <div className="bg-menu-background z-10 flex w-64 grow flex-col overflow-y-auto">
            {children}
          </div>
        </div>
      </Transition>
    </>
  );
};
